// Re-runs every time location changes to pick up new reveal elements
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useRevealObserver = () => {
  const location = useLocation();
  useEffect(() => {
    // Small delay so DOM is updated after route change
    const t = setTimeout(() => {
      const els = document.querySelectorAll('.reveal:not(.visible)');
      if (!els.length) return;
      const obs = new IntersectionObserver((entries) => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            e.target.classList.add('visible');
            obs.unobserve(e.target);
          }
        });
      }, { threshold: 0.10 });
      els.forEach(el => obs.observe(el));
      return () => obs.disconnect();
    }, 100);
    return () => clearTimeout(t);
  }, [location]);
};

export default useRevealObserver;
